import { createAsyncThunk } from '@reduxjs/toolkit';
import { instance } from '../../shared/services/app/instance';
import { setToken } from '../../shared/services/app/instance';
import * as toasty from '../../shared/toastify/toastify';
import { RootState } from '../store';

export const fetchDashboardStats = createAsyncThunk<
  any,
  void,
  { state: RootState; rejectValue: string }
>(
  'dashboard/fetchStats',
  async (_, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;
    setToken(token);

    try {
      const response = await instance.get('stats/dashboard');
      return response.data;
    } catch (error: any) {
      const message = error.response?.data?.message || 'Failed to fetch dashboard stats';
      toasty.toastError(message);
      return thunkApi.rejectWithValue(message);
    }
  }
);

export const fetchDashboardTrends = createAsyncThunk<
  any,
  number | undefined,
  { state: RootState; rejectValue: string }
>(
  'dashboard/fetchTrends',
  async (days = 30, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;
    setToken(token);

    try {
      const response = await instance.get('/stats/trends', { params: { days } });
      return response.data;
    } catch (error: any) {
      const message = error.response?.data?.message || 'Failed to fetch dashboard trends';
      toasty.toastError(message);
      return thunkApi.rejectWithValue(message);
    }
  }
);
